export function stringToBase64(str: string) {
  // Convert string to ArrayBuffer
  const encoder = new TextEncoder();
  const buffer = encoder.encode(str);

  // Convert ArrayBuffer to binary string
  const binaryString = new Uint8Array(buffer).reduce(
    (acc, byte) => acc + String.fromCharCode(byte),
    "",
  );

  // Convert binary string to base64
  const base64String = btoa(binaryString);
  return base64String;
}
